const React = require('react');
const ButtonBase = require('@material-ui/core/ButtonBase').default;
const UploadIcon = require('../../../icons/Upload');
const Slot = require('./Slot');


module.exports = (props) => {
  const {
    error,
  } = props;
  return (
    <div>
      <Slot className={`bcF44A.error` + (error ? ' error' : '')}>
        <UploadIcon className="w(|min)30 cF"/>
        <div className="ml20 pr50">{props.label}</div>
        {
          props.disabled ? null : (
            <ButtonBase
              className="dB*2 abs*2 s"
              component="div"
              onClick={props.onClick}
            />
          )
        }
      </Slot>
      {
        error ? (<div className="rlv">
          <div
            className="abs sh20 st f12 cEC4C4C fw4 ws ff$2"
          >Obligatory field</div>
        </div>) : null
      }
    </div>
  );
};
